export function calculateGridStyles(options) {
    const { layout } = options;
    const gridColumn = `${layout.column + 1} / span ${layout.width}`;
    return {
        label: {
            gridRow: '1 / span 1',
            gridColumn,
            display: 'flex',
            alignItems: 'flex-end'
        },
        input: {
            gridRow: '2 / span 1',
            gridColumn
        },
        container: {
            gridRow: '1 / span 2',
            gridColumn
        }
    };
}

//# sourceMappingURL=grid-styles.js.map